module.exports = __webpack_public_path__ + "static/media/stock_pick_chart.0badd4bf.PNG";